import { Component } from '@angular/core';

@Component({
    selector: 'not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.css']
})
/** not-found component*/
export class NotFoundComponent {
    /** not-found ctor */
    constructor() {

    }
}